import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import SwalComponent from './../../utils/custom-swal.component';
import { FormService } from './../../api/form.service';
import { TranslateService } from './../../api/translate.service';
import { UserProfileService } from './../../api/user-profile.service';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentHistoryComponent } from '../invoice-landing/invoice-grid/document-history/document-history.component';
import { DataObject } from '../../interfaces/data-objects';
@Component({
  selector: 'iv-upload-list',
  templateUrl: './upload-list.component.html',
  styleUrls: ['./upload-list.component.scss']
})
export class UploadListComponent {
  @ViewChild('warnAlert', { static: false }) private warnAlert: SwalComponent;
  _rowData: DataObject;
  @Input() fileList: any;
  @Input() headerText: string;
  @Input() disabled = false;
  @Input() hideDeleteBtn = false;
  @Input() transactionStatus: string;
  @Output() deleteFile = new EventEmitter();
  @Output() downloadFile = new EventEmitter();

  swalOptions: any;

  constructor(private formService: FormService,
    private translateService: TranslateService, 
    private userProfileService: UserProfileService,
    private mdDialog: MatDialog) {
    this.swalOptions = this.getSwalOptions();
  }
  ngOnInit(){
    this._rowData = this['rowData'];
  }
  removeFile(file) {
    this.warnAlert.fire().then(response => {
      if (response.value) {
        this.deleteFile.emit(file);
      }
    });
    return false;
  }

  download(file) {
    this.downloadFile.emit(file);
  }

  getSwalOptions() {
    // { showConfirmButton: true, showCloseButton: true, showCancelButton:true }
    const options = {
      showConfirmButton: true,
      showCloseButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      showCancelButton: true
    };
    return this.formService.getSwalOptions(options);
  }
  
  getTranslation(key: string): string {
    return this.translateService.getTranslation(key);
  }

  shouldHideDeleteForFinanceUser(): boolean {
    return this.userProfileService.shouldHideDeleteForFinanceUser(this.transactionStatus);
  }

  showDocumentsHistory(event) {
    event.stopPropagation();
    const shouldHideDelete = this.hideDeleteBtn || this.shouldHideDeleteForFinanceUser();
    const dialogRef = this.mdDialog.open(DocumentHistoryComponent, {
      height: '500px',
      width: '680px',
      disableClose: true,
      data: {
        dataSource: this.fileList,
        type: 'uploaded_documents',
        delete: !shouldHideDelete
      }
    });
    dialogRef.componentInstance.deleteConfirmationId.subscribe(file => {
      this.deleteFile.emit(file);
    });
    dialogRef.afterClosed();
  };
}
